<div style="padding: 50px; display: flex; align-items: center; justify-content: center; height: 75vh;">
  <a nz-button nzType="primary" [attr.href]="ssoUrl" style="color: white">
    CityU Web Sign In
  </a>
</div>
<div>
  <p>Access to this computer system is restricted to personnel authorized by the City University of Hong Kong.
    Unauthorized access to this system is forbidden.</p>
</div>
